<template>
  <div class='registration-page'>
    <div class='registration-page-container'>
      <h2 class='blind'>Step2</h2>
      <ul class="notice-text-list">
        <li class='notice-text'>아래의 가입하신 정보는 회원님들의 동의없이 공개되지 않으며, 개인정보보호정책에 의해 보호받습니다.</li>         
        <li class='notice-text'>LG유플러스 회원님의 개인정보보호를 위해 최선을 다할 것을 약속드립니다.</li>            
      </ul> 
      <div class='in-page-tab'>
        <ul class='in-page-tab-header'>
          <li :class="{'selected': tabInfo.activeTab === 1}">1단계</li>
          <li :class="{'selected': tabInfo.activeTab === 2}">2단계</li>
        </ul>  

    <!-- 여기부터 탭 1단계 -->    

        <div v-if="tabInfo.activeTab === 1" class='in-page-tab-content'>
          <BasicInformationSection/>
          <CustomerSection ref="customerSection"/>
          <div class='step-bottom-area input-wrap'>
            <button type='submit' @click="nextStep" class='primary-button mw100 pc-float-right'>
                다음으로 이동
            </button>
          </div>          
        </div>

    <!-- 여기부터 탭 2단계 -->    

        <div v-if="tabInfo.activeTab === 2" class='in-page-tab-content selected'>   
          <DeviceSection ref="deviceSection"/>
          <template v-if="payYn !== 'Y'">
            <FeePlanSection ref="feePlanSection" v-if="applType === 'move' || applType === 'new'" />
          </template>
          <SecureOptionSection ref="secureOptionSection"/>
          <ShipToAddrSection ref="shipToAddrSection"/>
          <!-- 아래문구는 중고폰일때 나오는 문구 -->   
          <ul class="notice-text-list" v-if="(this.imei+'').length < 1 && this.entrLoc == ''">
            <li class='notice-text'>중고 가입이 완료되면 USIM을 개통하여 작성주신 주소로 발송 드립니다.</li>            
          </ul> 

          <div class='step-bottom-area input-wrap'>
            <button @click="finalStep " class='primary-button mw100 pc-float-right'>
                다음으로 이동
            </button>
          </div>          
        </div>  
      </div>
    </div>
    <v-dialog/>
  </div>
</template>

<script>
  import BasicInformationSection from './BasicInformationSection'
  import CustomerSection from './CustomerSection'
  import DeviceSection from './DeviceSection'
  import FeePlanSection from './FeePlanSection'
  import SecureOptionSection from './SecureOptionSection'
  import ShipToAddrSection from './ShipToAddrSection'
  import { saveAppFormTemp, appFormEndding, getAppFormData } from '@/api/connectedCar/step2'
  import { saveIpinData, saveMobileAuthInfo } from '@/api/common'
  import { watchRefreshKeyPress } from '@/system/common'

  
  export default {
    name: 'ConnectedCarStep2',
    components: {
      BasicInformationSection,
      CustomerSection,
      DeviceSection,
      FeePlanSection,
      SecureOptionSection,
      ShipToAddrSection,
    },
    props: {},
    computed: {},
    data() {
      return {
        tabInfo: {
          activeTab: 1
        },
        payYn: '',
        applType: '',
        appfNo: '', // 신청서번호
        crypAppfNo: '',
        agreeYn: {}, // 전화면에서의 동의 여부
        custKdCd: 'B',
        onetAutnMthdDivsCd: '',
        imei: '',
        entrLoc: ''
      }
    },
    beforeCreate(){},
    created() {
      watchRefreshKeyPress()
    },
    mounted() {
      Object.assign(this.agreeYn, this.$route.params.termConditionCheckedStatus)
      this.onetAutnMthdDivsCd = this.$route.params.onetAutnMthdDivsCd
      this.imei = this.$store.state.connectedCar.common.imei
      this.$store.state.connectedCar.common.onetAutnMthdDivsCd = this.onetAutnMthdDivsCd;
      this.$store.state.processIndicator.step1 = false
      this.$store.state.processIndicator.step2 = true
      this.$store.state.processIndicator.step3 = false
      this.payYn = this.$store.state.connectedCar.common.payYn
      this.entrLoc = this.$store.state.connectedCar.common.entrLoc
      this.applType = this.$store.state.connectedCar.common.opmkEntrKdCd
    },
    methods: {
      /** 
       * Function    : nextStep
       * Description : 임시저장후 다음 step으로 이동
       **/
      nextStep() {      
        if(!this.$refs.customerSection.validCustomer()){  // 가입정보 validation
          return
        }
        let customerInfo = this.$refs.customerSection.retrieveData
        let commonData = this.$store.state.connectedCar.common
        let tempCustSSN2 = customerInfo.custSSN2
        if(tempCustSSN2.substr(0,1) === '5' || tempCustSSN2.substr(0,1) === '6') {
          this.custKdCd = 'D'
        } else {
          this.custKdCd = 'B'
        }
        let reqData = {
          entrRsvTruthInfo: {
            onetMblAppfNo: '', // 신청서 아이디
            onetIdcdDivsCd: customerInfo.inqDvCd1, // 신분증진위여부 타입
            onetIndvDivsCd: '01', //진위여부 (본인 :01, 법정대리인: 03)
            agrYn: 'Y', 
            drvLcnsNo: customerInfo.drvLcnsNo ? window.btoa(customerInfo.drvLcnsNo) : '', // 면허증 등록번호
            drvLcnsIsuAreaCd: customerInfo.drvLcnsIsuAreaCd, // 면허증 지역코드
            custNm: customerInfo.custName, // 고객이름
            isuDt: customerInfo.isuDt, // 발급일자
            monmCsntNo: customerInfo.monmCsntNo // 보훈 번호
          },
          opmktRegistrationCapture: {
            appfNo: '',
            crypAppfNo: '',
            custKdCd: this.custKdCd, // 고객 유형 코드 B => 본인밖에 가입되지 않기 때문에 B 하드 코딩
            opmkNo: commonData.opmkNo, // 오픈마켓 코드
            onetKdCd: commonData.opmkEntrKdCd, // 가입유형코드
            sbgnDealCd: commonData.dealCd, // 대리점 코드
            dealNm: commonData.dealNm ? commonData.dealNm : commonData.agentName,
            entrRqstFomNo: commonData.onetAppfFomNo, // 폼 아이디
            aplcNm: window.btoa(encodeURIComponent(customerInfo.custName)),  // 고객이름
            // 2020-03-04 수정 박성진
            // 저장시 aplcErrno -> aplcDerno
            aplcDerno: window.btoa(customerInfo.custSSN1 + customerInfo.custSSN2), // 주민번호
            //aplcTlno: customerInfo.custTelSMS, // 연락처 장희정 수정 2022.03.29
            aplcEmalAddr: `${customerInfo.custEmail1}@${customerInfo.custEmail2}`, // 이메일 주소
            bltxRcepMthdCd: customerInfo.chargeSendType, // 청구수령 선택 구분 코드
            billDivsCd: customerInfo.chargeType, // 청구위치 구분코드
            crplZpcd: customerInfo.chargePost, // 청구지 우편 주소
            crplAddr: customerInfo.chargeAddr1, // 청구지 주소
            crplDadr: customerInfo.chargeAddr2, // 청구지 상세 주소
            // 약관동의여부 데이터
            custInfoGthrAgrYn: this.agreeYn.requiredForPersonalInformation ? 'Y' : 'N',
            pnifPuseTrstAgrYn: this.agreeYn.optionalMarketingOfferPersonal ? 'Y' : 'N',
            mblAdRcpAgrYn: this.agreeYn.optionalMarketingOfferAds ? 'Y' : 'N',
            locFndnInfoOfrSvcAgrYn: this.agreeYn.optionalMarketingOffer ? 'Y' : 'N',
            dvicMdlCd: commonData.trmMdlCd, // 디바이스 모델 코드
            dvicMdlNm: commonData.trmMdlNm,
            trmSrno: commonData.itemSn,  // 일련 번호
            opmkNm: this.$store.state.connectedCar.dealerInfo.openMarketName, // 오픈마켓명
            svcDivsCd: this.$store.state.connectedCar.dealerInfo.mblSvcDivsCd, // 모바일 서비스 구분 코드
            autnMthdDivsCd: this.onetAutnMthdDivsCd,
            sbgnProdNo:commonData.ctn,
            aplcTlno: customerInfo.custTel, // 연락처 장희정 수정 2022.03.29
            rotrRqstYn: this.$store.state.connectedCar.dealerInfo.rotrRqstCd  // 커넥티드 카일 경우 C   장희정 수정 2022.03.29
          },
          lawcAgntEntrRsvTruthInfo: null,
          step: "2"
        }
        if (this.payYn === 'Y' || this.entrLoc === 'B') {
          let payInfo = {
            // 2020-03-04 수정 박성진
            // 저장시 crypAcctCardNo -> acctCardNo
            acctCardNo: window.btoa(customerInfo.bankAccount), // 계좌/카드 번호
            ccrdValdTermEndYymm: customerInfo.lgdExpyear+customerInfo.lgdExpmon, // 카드 유효 기간
            wdrwAgrYn: customerInfo.payAgreeYnChk ? 'Y' : 'N', // 출금 결제 동의 여부
            bankNm: customerInfo.selBankName, // 은행/카드사 명
            pymnDivsCd: '1', // 납부자 구분코드 1: 본인 2: 미성년 => 커넥티드카는 미성년 가입이 없다.
            pymnNm: window.btoa(encodeURIComponent(customerInfo.custName)), // 납부자 명
            // 2020-03-04 수정 박성진
            // 저장시 pymnErrno -> pymnDerno
            pymnDerno: window.btoa(customerInfo.custSSN1 + customerInfo.custSSN2), // 납부자 주민번호
            pymnEmalAddr: `${customerInfo.custEmail1}@${customerInfo.custEmail2}`, // 납부자 이메일 주소
            paymMthdDivsCd: customerInfo.payType, // 납부 타입 코드
          }

          if(customerInfo.payType == 'C') {
            payInfo.onetCdcoCd = customerInfo.selBank; // 카드사 코드
          } else {
            payInfo.onetBankCd = customerInfo.selBank; // 은행 코드
          }

          Object.assign(reqData.opmktRegistrationCapture, payInfo)
        }
        
        // FIXME TEST를 위한 주석처리 
         if (this.isValid()) {
            saveAppFormTemp(reqData).then(res => {
              if(res.data.rsltCd == "FAIL") {
                this.openAlert('인증 오류', res.data.rsltMsg)
                return;
              }

              this.appfNo = res.data.appfNo
              // 암호화 appfNo
              this.crypAppfNo = res.data.crypAppfNo
              this.tabInfo.activeTab = 2
              let address = {
                dlvRcipNm: res.data.aplcNm, 
                dlplZpcd: res.data.crplZpcd, 
                dlplBadr: res.data.crplAddr,
                dlplDadr: res.data.crplDadr,
                dlplTlno: res.data.aplcTlno
              }
              this.$store.commit('SET_CONNECTED_CAR_ADDRESS', address)
              let mobileData = {}
              mobileData = {
                onetMblAppfNo: res.data.appfNo,
                dealCd: res.data.sbgnDealCd,
                juminNo: this.$store.state.connectedCar.personalInfo.birthDay,
                custName: this.$store.state.connectedCar.personalInfo.name,
                smsval: this.$store.state.connectedCar.common.smsval,
                //tradeid: this.$store.state.connectedCar.personalInfo.certNum,
                //mobilid: '-',
                no: this.$store.state.connectedCar.personalInfo.phoneNo,
                prdtnm: 'SMS',
                tradeid: this.$store.state.connectedCar.common.tradeid
              }
              // 인증정보 저장
              saveMobileAuthInfo(mobileData).then(res => {
              })
         
            })
         }
      },

      /** 
       * Function    : finalStep
       * Description : 정보 저장하고 step3로 이동
       **/
      finalStep() {
        if(!this.$refs.deviceSection.validDevice()){  // 가입내역 validation
          return
        }
        if((this.imei+"").length < 1 && this.entrLoc == '') {
          if(!this.$refs.shipToAddrSection.validShipToAddr()){  // 배송정보 validation
            return
          }
        }
        let reqData = {
          accessType: 'E',
          crypAppfNo: this.crypAppfNo
        }
        // 후석 수동 입력한 가입정보 common에 추가
        if(this.entrLoc == 'B'){
          let deviceInfo = {
            itemSn : this.$refs.deviceSection.retrieveData.itemSn,
            ctn : this.$refs.deviceSection.retrieveData.ctn,
            usimMdlNm : this.$refs.deviceSection.retrieveData.usimMdlNm,
            usimSn : this.$refs.deviceSection.retrieveData.usimSn
          }
          this.$store.commit('SET_DEVICE_INFO', deviceInfo)
        }
        getAppFormData(reqData).then(res => {
          let deviceSectionInfo = {} // DEVICE 영역 데이터를 담기 위한 객체
          let feePlanSectionInfo = {} // 요금제 영역 데이터를 담기 위한 객체
          let shipToAddrSectionInfo = {} // 배송지 영역 데이터를 담기 위한 객체
          let secureOptionSectionInfo = {} // 보안등급 영역 데이터를 담기 위한 객체
          let reqData = {}

          deviceSectionInfo = this.$refs.deviceSection.retrieveData
          shipToAddrSectionInfo = this.$refs.shipToAddrSection.retrieveData
          secureOptionSectionInfo = this.$refs.secureOptionSection.retrieveData
          if (this.payYn !== 'Y') {
            feePlanSectionInfo = this.$refs.feePlanSection.retrieveData
          }

          // 데이터를 전부 합쳐서 저장
          Object.assign(reqData, deviceSectionInfo, feePlanSectionInfo, shipToAddrSectionInfo, secureOptionSectionInfo)
          reqData.dvicMdlCd = deviceSectionInfo.trmMdlCd ? deviceSectionInfo.trmMdlCd : ''
          reqData.dvicMdlNm = deviceSectionInfo.trmMdlNm ? deviceSectionInfo.trmMdlNm : ''
          reqData.onetAppfFomNo = res.data.opmktRegistrationCapture.entrRqstFomNo
          reqData.appfNo = res.data.opmktRegistrationCapture.appfNo
          reqData.crypAppfNo = res.data.opmktRegistrationCapture.crypAppfNo
          reqData.dealCd = this.$store.state.connectedCar.common.dealCd
          reqData.dealNm = this.$store.state.connectedCar.common.dealNm ? this.$store.state.connectedCar.common.dealNm : this.$store.state.connectedCar.dealerInfo.dealNm
          reqData.opmkNo = this.$store.state.connectedCar.common.opmkNo
          reqData.svcDivsCd = this.$store.state.connectedCar.dealerInfo.mblSvcDivsCd // 모바일 서비스 구분 코드
          reqData.autnMthdDivsCd = this.onetAutnMthdDivsCd // 인증 구분 코드 I: IPIN 인증,  M: KMC
          reqData.imei = this.$store.state.connectedCar.common.imei
          reqData.ctn = this.$store.state.connectedCar.common.ctn
          reqData.itemSn = this.$store.state.connectedCar.common.itemSn
          if(this.payYn !== 'Y'){
            reqData.ppNm = this.$refs.feePlanSection.retrieveData.ppNm
            reqData.ppCd = this.$refs.feePlanSection.retrieveData.ppCd
          } else {
            reqData.ppNm = this.$store.state.connectedCar.common.phonePayStyle
            reqData.ppCd = this.$store.state.connectedCar.common.phonePayStyleCd
          }
          
          // reqData.
          // if (this.payYn !== 'Y') {
          //   reqData.ppNm = deviceSectionInfo.phonePayStyle
          // } else {
          //   reqData.ppNm = feePlanSectionInfo.phonePayStyle
          // }

          appFormEndding(reqData).then(res => {
            let dsRsltInfo = res.data.dsRsltInfo
            if (dsRsltInfo.rsltCd === 'FAIL') {
              this.openAlert('저장 오류', dsRsltInfo.rsltMsg)
            } else {
              this.$router.push({
                name: 'ConnectedCarStep3',
                props: true,
                params: {
                  appfNo: this.appfNo,
                  crypAppfNo: reqData.crypAppfNo
                }
              })
            }
          }).catch(e => {
          })
        })
      },

      /** 
       * Function    : isValid
       * Description : 고객정보 필수값 validation
       **/
      isValid() {
        // 고객정보 validation
        let customerSection = this.$refs.customerSection
        let title = ''
        let message = ''
        //alert(customerSection.smsConfirm)
        if (!customerSection.smsConfirm) {
          title = '모바일인증'
          message = '모바일 인증을 해주세요'
          this.openAlert(title, message)
          return false
          // return true
        } else if (!customerSection.emailConfirm) {
          title = '이메일인증'
          message = '이메일 인증을 해주세요'
          this.openAlert(title, message)
          return false
        } else if (customerSection.payYn === 'Y' && !customerSection.retrieveData.payAgreeYnChk ) {
          title = '출금결제동의여부'
          message = '출금결제를 동의 해주세요'
          this.openAlert(title, message)
          return false
       } 
        return true
      },

      /** 
       * Function    : openAlert
       * Description : 기본 alert 호출 함수
       **/
      openAlert(title, message) {
        this.$modal.show('dialog', {
          title: title,
          text: message,
          buttons: [{
            title: '확인',
            class: 'primary-button',
          }]
        })
      }
    },
  }
</script>

<style scoped>
</style>